import React from 'react';
import { FormattedMessage } from 'react-intl';
import { intl } from '../../../locales/localesConfig';
import UserTooling from '../../../tooling/userTooling';
import JavascriptUtilsTooling from '../../../tooling/javascriptUtilsTooling';
import InterfaceTooling from '../../../tooling/interfaceTooling';
import FormatTooling from '../../../tooling/formatTooling';
import Constants from '../../../definitions/constants';

import GlassPopup from '../common/interface/glassPopup';
import TextBox from '../common/inputs/textBox';
import Select from '../common/inputs/select';
import FetchAutocompleteSelect from '../common/inputs/fetchAutocompleteSelect';
import Label from '../common/inputs/label';
import CheckBox from '../common/inputs/checkBox';
import ErrorFeedback from '../common/feedback/errorFeedback';

const FormPopup = props => {
  const {
    handleShowPopup,
    handleOnChangeForm,
    handleButton,
    loadingButton,
    fullLoading,
    statusButton,
    formData,
    lists,
    groupsData,
    selectedPeriodName,
    calculationUnitsData,
    calculationUnitsLoading,
    calculationUnitsFetchAction,
    headers,
    errors,
    popupState
  } = props;
  let firstMetric = true;
  return (
    <GlassPopup
      className="form_popup metric_values_form_popup"
      title={(<FormattedMessage 
         id={(formData && formData.ids) ? "metricDataAdmin.edit" : "metricDataAdmin.create"}
       />)}
      buttonText={(<FormattedMessage 
         id={(formData && formData.ids) ? "metricDataAdmin.edit" : "metricDataAdmin.create"}
       />)}
      type={Constants.interface.popup.types.LATERAL}
      {...props}
    >
      <ErrorFeedback
        status={statusButton}
        fieldErrors={errors}
        localesFieldsPath="metricDataAdmin.fields"
      />
      <Label 
        label={<FormattedMessage id="metricDataAdmin.formDimensionsLabel"/>}
      />
      {(formData && formData.info) &&
        formData.info.map((column_info,i) => {
          let returnComponents = [];
          let values = formData.values;
          let value = (values) ? values[i] : "";
          let header = (headers) ? headers[i] : "";
          let path = i;
          let disabled = (formData.ids && !column_info.is_metric) ? true : false;
          let systemDefectOption = column_info.is_metric ? [] : [{id: Constants.metricDataAdmin.systemDefect, name: intl.formatMessage({ id: "metricDataAdmin.defect"})}]
          if(column_info.is_metric && firstMetric) {
            firstMetric = false;
            returnComponents.push((
              <div key={"label_metric"}>
                <Label 
                  label={<FormattedMessage id="metricDataAdmin.formMetricsLabel"/>}
                />
                {(formData && formData.ids) && (
                  <label className="form_info">
                    <FormattedMessage 
                      id={"metricDataAdmin.editMetricsEmptyHelp"}
                    />
                  </label>
                )}
              </div>
            ));
          }
          if(column_info.system_entity_class && !formData.ids) {
            switch (column_info.system_entity_class) {
              case Constants.systemDimensionsIdentifiers.period:
                returnComponents.push((
                  <TextBox 
                    key={i}
                    styleType={Constants.interface.inputs.styleType.OUTLINED}
                    type={Constants.interface.inputs.type.TEXT}
                    disabled={true}
                    value={selectedPeriodName}
                    labelLocale={header}
                    dataType={column_info.data_type}
                  />
                ));
                break;
              case Constants.systemDimensionsIdentifiers.group:
                returnComponents.push((
                  <Select 
                    key={i}
                    data-path={path}
                    value={value}
                    onChange={handleOnChangeForm}
                    labelLocale={header}
                    options={InterfaceTooling.getSelectArrayFromArrayOfObjects(systemDefectOption.concat(groupsData), "id", "name")}
                  />
                ));
                break;
              case Constants.systemDimensionsIdentifiers.calculationUnit:
                returnComponents.push((
                  <FetchAutocompleteSelect
                    key={i}
                    data-path={path}
                    value={value}
                    onChange={handleOnChangeForm}
                    labelLocale={header}
                    options={calculationUnitsData ? InterfaceTooling.getSelectArrayFromArrayOfObjects(systemDefectOption.concat(calculationUnitsData), "id", "name", false) : []}
                    valueAccesor={"id"}
                    labelAccesor={"name"}
                    fetchListAction={calculationUnitsFetchAction}
                    loadingFetch={calculationUnitsLoading}
                  />
                ));
                break;
            }
          }
          else if(lists && lists[i] && column_info.is_list && (!formData.ids || column_info.is_metric)) {
            returnComponents.push((
              <Select 
                key={i}
                data-path={path}
                disabled={disabled}
                value={value}
                formatter={FormatTooling.getMetricDatasFormatTypeFunction(column_info.data_type)}
                onChange={handleOnChangeForm}
                labelLocale={header}
                options={InterfaceTooling.getSelectArrayFromArrayOfObjects(systemDefectOption, "id", "name").concat(InterfaceTooling.getSelectArrayFromArray(lists[i].values, false))}
              />
            ));
          }
          else {
            returnComponents.push((
              <TextBox 
                key={i}
                styleType={Constants.interface.inputs.styleType.OUTLINED}
                type={Constants.interface.inputs.type.TEXT}
                data-path={path}
                disabled={disabled}
                value={value}
                onChange={handleOnChangeForm}
                labelLocale={header + ((!column_info.system_entity_class && (!formData.ids || column_info.is_metric)) ? " (" + intl.formatMessage({ id: "metricAdmin.fields.selectValues.data_type.helpers." + column_info.data_type}) + ")" : "")}
                dataType={column_info.data_type}
              />
            ));
          }
          return returnComponents;
        })
      }
    </GlassPopup>
  );
};

export default FormPopup;



// WEBPACK FOOTER //
// ./source/client/components/metricDataAdmin/formPopup.jsx